<template>
    <el-dialog
      width="618px"
      title="预约演示"
      :visible.sync="show"
      :before-close="handleClose"
      class="reg-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :lock-scroll="false"
    >
      <el-form
        :rules="rules"
        ref="submitForm"
        label-position="right"
        label-width="100px"
        :model="submitForm"
        @validate="changeSjh"
      >
        <el-form-item label="姓名：" prop="xm">
          <el-input class="form-input" v-model="submitForm.xm"></el-input>
        </el-form-item>
        <el-form-item label="企业名称：" prop="qymc">
          <el-input class="form-input" v-model="submitForm.qymc"></el-input>
        </el-form-item>
        <el-form-item label="需求描述：" prop="xqms">
          <el-input class="form-input" v-model="submitForm.xqms"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="sjh">
          <el-input
            class="form-input"
            v-model="submitForm.sjh"
            maxlength="11"
          />
        </el-form-item>
        <el-form-item label="验证码：" prop="yzm">
          <el-input
            :class="sendBtn ? 'yzm active' : 'yzm'"
            v-model="submitForm.yzm"
            maxlength="11"
          >
            <div v-if="showDjs" slot="append">{{ count }}秒后重新获取</div>
            <div v-else slot="append" @click="getyzm">{{yzmtext}}</div>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="reg-btn">
        <div class="submit-btn" @click="handleSubmit">提交信息</div>
      </span>
    </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      yzmtext: '获取验证码',
      sendBtn: false,
      count: 60,
      showDjs: false,
      loading: false,
      timer: null,
      submitForm: {
        token: 'ECE24045D0385815853B374463C9FCF2',
        sjh: '',
        xm: '',
        qymc: '',
        xqms: '',
        yzm: '',
        uuid: ''
      },
      rules: {
        xm: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        qymc: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        sjh: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: '请输入合法手机号/电话号',
            trigger: 'blur'
          }
        ],
        xqms: [{ required: true, message: '请输入需求描述', trigger: 'blur' }],
        yzm: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getyzm () {
      if (!this.sendBtn) {
        return
      }
      this.loading = true
      this.$axios({
        method: 'post',
        url: 'https://www.esbpm.com:8669/SRMRehearsal/ZSSRMSMS.ashx',
        data: this.$qs.stringify({
          token: this.submitForm.token,
          sjh: this.submitForm.sjh
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res) => {
        let { data } = res
        if (data.success) {
          this.getCode()
          this.$message.success('发送成功')
          this.submitForm.uuid = data.uuid
        } else {
          this.$message.error(data.errorMessage)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    changeSjh (prop, res) {
      if (prop === 'sjh') {
        this.sendBtn = res
      }
    },
    handleClose () {
      this.$emit('update:show', false)
      this.$refs.submitForm.resetFields()
      clearInterval(this.timer)
      this.count = 0
      this.showDjs = false
    },
    getCode () {
      if (!this.timer) {
        var _this = this
        this.timer = setInterval(() => {
          if (_this.count > 1) {
            _this.showDjs = true
            _this.count--
          } else {
            clearInterval(_this.timer)
            _this.timer = null
            _this.showDjs = false
            _this.count = 60
          }
        }, 1000)
      }
    },
    handleSubmit () {
      this.$refs.submitForm.validate((valid) => {
        if (valid) {
          console.log('this.submitForm', this.submitForm)
          this.$axios({
            method: 'post',
            url: 'https://www.esbpm.com:8669/SRMRehearsal/ZSSRMindex.ashx',
            data: this.$qs.stringify(this.submitForm),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((res) => {
            let { data } = res
            if (data.success) {
              this.$message.success('提交成功')
              setTimeout(() => {
                this.handleClose()
              }, 2000)
            } else {
              this.$message.error(data.errorMessage)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.yzm{
  >>> .el-input-group__append {
    cursor: pointer;
  }
}
.active{
  >>> .el-input-group__append {
    background-color: #e8f5fd;
    color: #51a0f0;
  }
}
.reg-dialog {
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  ::v-deep .el-dialog__header {
    background-color: #0c55dd !important;
    padding: 24px;
    display: flex;
    align-items: center;
    .el-dialog__title {
      color: #fff;
      font-size: 20px;
    }
    .el-dialog__headerbtn {
      font-size: 30px;
      color: #fff;
      .el-dialog__close {
        color: #fff;
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 40px;
    padding-bottom: 0;
  }
  ::v-deep .el-dialog__footer {
    padding-bottom: 40px;
  }
}
.form-input {
  height: 54px;
  ::v-deep .el-input__inner {
    height: 100% !important;
    cursor: pointer;
  }
}
.reg-btn {
  display: flex;
  justify-content: center;
  .submit-btn {
    width: 128px;
    height: 45px;
    background-color: #0c55dd;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register-dialog.vue